import React from "react";
import Stats from "../../../components/landing/stats";
import Target from "../../../components/landing/target";
import WhyToffee from "../../../components/landing/whyToffee";
import Testimonials from "../../../components/landing/testimonial";
import Coverage from "../../../components/landing/coverage";
import QA from "../../../components/landing/qa";
import Footer from "../../../components/common/footer";
import "./landingPage.scss";
import Products from "../../../components/landing/products";
import WelcomeNew from "../../../components/landing/welcomeNew";
import InspiredBy from "../../../components/landing/inspiredBy";
import AxiosReactClient from "../../../utilities/AxiosRestClient";
import Cookies from "js-cookie";
import Share from "../../../components/landing/share";
import HowToBuy from "../../../components/landing/howToBuy";

class LandingPage extends React.Component {
  state = {};
  constructor(props) {
    super(props);
    // this.getUserDetails(props.match.params["id"], props.match.params["token"]);
  }
  getUserDetails(id, token) {
    Cookies.remove("name");
    Cookies.remove("mobile");
    Cookies.remove("email");
    Cookies.remove("dob");
    AxiosReactClient.getRequestWithoutToken(
      "https://dev.toffeeinsurance.com/api/life/get_user_data/" +
        id +
        "/" +
        token,
      {}
    )
      .then(response => {
        console.log(response.data.data["user_data"]);
        this.setState(response.data.data["user_data"]);
        Cookies.set("name", response.data.data["user_data"]["name"]);
        Cookies.set("mobile", response.data.data["user_data"]["mobile"]);
        Cookies.set("email", response.data.data["user_data"]["email"]);
        Cookies.set(
          "dob",
          response.data.data["user_data"]["dob"]
            ? response.data.data["user_data"]["dob"]
            : ""
        );
        console.log(typeof response.data.data["user_data"]["dob"]);
      })
      .catch(err => {
        console.log(err);
      });
  }
  render() {
    return (
      <div className="page-container">
        <WelcomeNew userdata={this.state} />
        <Products />
        <Stats />
        <WhyToffee />
        <Target />
        <HowToBuy />
        <Testimonials />
        <Share />
        {/*<Achievements />*/}
        <QA />
        <InspiredBy />
        <Coverage />
        <Footer />
      </div>
    );
  }
}

export default LandingPage;
